import { useStores } from '@littlebird/sdk';
import { useParams } from '@tanstack/react-router';
import { computed } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Fragment } from 'react';

import { Icons } from '@/assets/icons/icons';
import { IconButton, Text, XStack } from '@/components/ui';
import { ShareChatPopover } from '@/features/chat/chat.modals';
import { userStore } from '@/stores/user.store';

import { SharedChatType } from '../chat/shared-chat/shared-chat.types';

export const ArenaHeader = observer(() => {
  const { arenaId } = useParams({ strict: false });
  const { arenas: arenaStore } = useStores();
  const agents = computed(() => arenaStore.get(arenaId ?? '')?.agents).get();
  const chatIds = Object.values(arenaStore.get(arenaId ?? '')?.threadIds ?? {});

  if (!agents?.length) return null;

  return (
    <XStack className="pl-1 pr-2 h-12 items-center justify-between w-full">
      <XStack className="items-center gap-2">
        <Text fontWeight="medium">Colosseum</Text>
      </XStack>
      <div className="text-sm truncate w-60 sm:w-80 lg:w-[700px] 2xl:w-auto 2xl:max-w-[1000px]">
        {agents?.map((agent, index) => (
          <Fragment key={agent}>
            {agent}
            {index !== agents.length - 1 && (
              <span className="text-foreground-subtle truncate">{' vs '}</span>
            )}
          </Fragment>
        ))}
      </div>
      {chatIds && chatIds.length > 0 && !userStore.hasSignedBaa && (
        <ShareChatPopover chatIds={chatIds} type={SharedChatType.Arena}>
          <IconButton icon={Icons.share} variant="ghost" size="sm" />
        </ShareChatPopover>
      )}
    </XStack>
  );
});
